import { PermissionLevel, ResourcePermissionsQuery } from "@/graphql";

export type SharePermissionState = "VIEW" | "EDIT" | "SHARE" | "REMOVE";

// Base types for resource permissions
export type ResourcePermission =
  ResourcePermissionsQuery["resourcePermissions"][number];

export type ResourcePermissionUser = NonNullable<ResourcePermission["user"]> & {
  originalPermissionLevel?: PermissionLevel | null;
  shareStatus?: SharePermissionState;
  remove?: boolean;
  permissionId?: string;
  isOwner?: boolean;
};

export type ResourcePermissionGroup = NonNullable<
  ResourcePermission["workspaceGroup"]
> & {
  originalPermissionLevel?: PermissionLevel | null;
  shareStatus?: SharePermissionState;
  remove?: boolean;
  permissionId?: string;
};

export type ResourcePermissionProgram = NonNullable<
  ResourcePermission["program"]
> & {
  originalPermissionLevel?: PermissionLevel | null;
  shareStatus?: SharePermissionState;
  permissionId?: string;
};

// Processed permissions result
export interface ProcessedPermissions {
  users: ResourcePermissionUser[];
  groups: ResourcePermissionGroup[];
  programs: ResourcePermissionProgram[];
  owner?: ResourcePermissionUser;
}

// Common permission constants
export const DEFAULT_PERMISSION: SharePermissionState = "VIEW";
